import { cn } from '../../utils/cn';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Render as a circle (sets aspect-square + rounded-full). */
  circle?: boolean;
}

/**
 * Single shimmering placeholder block. Use as a 1:1 stand-in for a piece of
 * content while it's loading — match the real thing's height/width.
 *
 * Example: <Skeleton className="h-4 w-32" />, <Skeleton circle className="h-10 w-10" />
 */
export function Skeleton({ className, circle, ...rest }: SkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-live="polite"
      className={cn(
        'bg-muted animate-pulse rounded',
        circle && 'rounded-full aspect-square',
        className,
      )}
      {...rest}
    />
  );
}

/** Compact text-line skeleton — defaults to h-4. */
export function SkeletonText({ className, ...rest }: SkeletonProps) {
  return <Skeleton className={cn('h-4 w-full', className)} {...rest} />;
}

export default Skeleton;
